import { render, staticRenderFns } from "./CambiaStatoConsegna.vue?vue&type=template&id=1fad0701&"
import script from "./CambiaStatoConsegna.vue?vue&type=script&lang=js&"
export * from "./CambiaStatoConsegna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports